import { cloneDeep, set } from 'lodash';
import { enqueueNotification } from './notifications';
import { AuthApiService } from '../services';

// ACTION_TYPES ////////////////////////////////////////////////////////////////

export const FETCH_GLOBAL_SETTINGS_PREFIX = 'FETCH_GLOBAL_SETTINGS';
export const FETCH_GLOBAL_SETTINGS_REQUEST_ACTION = `${FETCH_GLOBAL_SETTINGS_PREFIX}_REQUEST_ACTION`;
export const FETCH_GLOBAL_SETTINGS_SUCCESS_ACTION = `${FETCH_GLOBAL_SETTINGS_PREFIX}_SUCCESS_ACTION`;
export const FETCH_GLOBAL_SETTINGS_FAILURE_ACTION = `${FETCH_GLOBAL_SETTINGS_PREFIX}_FAILURE_ACTION`;

export const UPDATE_GLOBAL_SETTINGS_PREFIX = 'UPDATE_GLOBAL_SETTINGS';
export const UPDATE_GLOBAL_SETTINGS_REQUEST_ACTION = `${UPDATE_GLOBAL_SETTINGS_PREFIX}_REQUEST_ACTION`;
export const UPDATE_GLOBAL_SETTINGS_SUCCESS_ACTION = `${UPDATE_GLOBAL_SETTINGS_PREFIX}_SUCCESS_ACTION`;
export const UPDATE_GLOBAL_SETTINGS_FAILURE_ACTION = `${UPDATE_GLOBAL_SETTINGS_PREFIX}_FAILURE_ACTION`;

// INITIAL STATE ///////////////////////////////////////////////////////////////

const initialState = {
  global: []
};

// STATE ///////////////////////////////////////////////////////////////////////
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLOBAL_SETTINGS_SUCCESS_ACTION:
      return {
        ...state,
        global: action.payload
      };
    case UPDATE_GLOBAL_SETTINGS_SUCCESS_ACTION: {
      const source = Array.isArray(state.global) ? {} : state.global || {};
      const global = cloneDeep(source);
      Object.entries(action.payload).forEach(([key, value]) => {
        set(global, key, value);
      });
      return {
        ...state,
        global
      };
    }
    default:
      return state;
  }
};

// ACTIONS /////////////////////////////////////////////////////////////////////

export function fetchGlobalSettingsAction() {
  return dispatch => {
    dispatch({ type: FETCH_GLOBAL_SETTINGS_REQUEST_ACTION });
    const authService = new AuthApiService();
    return authService
      .getGlobalSettings()
      .then(response => {
        dispatch({ type: FETCH_GLOBAL_SETTINGS_SUCCESS_ACTION, payload: response.settings });
      })
      .catch(error => {
        dispatch({
          type: FETCH_GLOBAL_SETTINGS_FAILURE_ACTION,
          payload: { message: error.message }
        });
        dispatch(enqueueNotification('error', error.message));
      });
  };
}

export function updateGlobalSettingsAction(settings) {
  return dispatch => {
    dispatch({ type: UPDATE_GLOBAL_SETTINGS_REQUEST_ACTION });
    const authService = new AuthApiService();
    return authService
      .updateGlobalSettings(settings)
      .then(response => {
        dispatch({ type: UPDATE_GLOBAL_SETTINGS_SUCCESS_ACTION, payload: settings });
        dispatch(enqueueNotification('success', response.message));
        return true;
      })
      .catch(error => {
        dispatch({
          type: UPDATE_GLOBAL_SETTINGS_FAILURE_ACTION,
          payload: { message: error.message }
        });
        dispatch(enqueueNotification('error', error.message));
        return false;
      });
  };
}
